export const ACTUALIZAR_LIST_CONSUMOS = "ACTUALIZAR_LIST_CONSUMOS";
export const MODIFICAR_CONSUMOS = "MODIFICAR_CONSUMOS";
export const AGREGAR_CONSUMO = "AGREGAR_CONSUMO";  
export const ELIMINAR_CONSUMO = "ELIMINAR_CONSUMO";